import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, CheckGrid, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { COMPLIANCE_ITEMS, TRADING_DISCLAIMER } from "../data/content";

export default function Compliance() {
    return (
        <div className="grain bg-navy-deep" data-testid="compliance-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Compliance & Due Diligence | International Trading — Viet Medica Ltd",
                        description:
                            "How Viet Medica Ltd approaches verification, KYC, sanctions screening, inspection coordination and payment security in international trading.",
                        path: "/compliance-due-diligence",
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Compliance" }]}
                    eyebrow="International Trading"
                    title="Compliance &"
                    titleEm="Due Diligence."
                    copy="Responsible international trade depends on verification at every stage. Our coordination process builds these checks into each transaction, and independent professional providers are involved wherever formal verification is required."
                />

                <PageSection eyebrow="Our Framework" title="What Every Transaction Considers" testid="compliance-items">
                    <CheckGrid items={COMPLIANCE_ITEMS} cols={3} />
                    <div className="mt-10 space-y-6">
                        <DisclaimerBox
                            text="Viet Medica Ltd provides introductions and international business coordination. We are not a producer, refinery, manufacturer, vessel owner or guaranteed supplier, and we do not perform regulated inspections or legal verification ourselves."
                            testid="compliance-role-note"
                        />
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid="compliance-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Trade with verification built in."
                            primary={{ label: "Trading Enquiry", to: "/trading-enquiry", testid: "compliance-enquiry-cta" }}
                            secondary={{ label: "Trading Process", to: "/trading-process", testid: "compliance-process-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
